export default "__VITE_ASSET__CteHZ3$u__"